import { createSelector } from "reselect";

export const getSubscriptionBrakeDownPrice = (state) => state.subscription.priceBrakeDown;

export const getBrakeDownPriceFromSubscriptionTotal = createSelector(
  getSubscriptionBrakeDownPrice,
  (subscriptions) => subscriptions.priceBrakeDown.total
);

export const getPriceBreakdown = createSelector(getSubscriptionBrakeDownPrice, (priceBreakdown) => {
  return priceBreakdown;
});
